import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import es from './locales/es/translation.json';
import en from './locales/en/translation.json';
import ar from './locales/ar/translation.json';
import ko from './locales/ko/translation.json';

const detectLanguage = () => {
  const saved = localStorage.getItem('language');
  if (saved) return saved;
  const lang = (navigator.language || '').toLowerCase();
  if (lang.startsWith('ar')) return 'ar';
  if (lang.startsWith('es')) return 'es';
  if (lang.startsWith('ko')) return 'ko';
  return 'en';
};

const detectedLng = detectLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: { es: { translation: es }, en: { translation: en }, ar: { translation: ar }, ko: { translation: ko } },
    lng: detectedLng,
    fallbackLng: 'es',
    interpolation: { escapeValue: false },
  });

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
});

// Apply on load
document.documentElement.lang = detectedLng;
document.documentElement.dir = detectedLng === 'ar' ? 'rtl' : 'ltr';

export default i18n;
